<template>
  <div class="common-footer">
    <div class="footer-main">
      <div class="logo_copyright">
        <img src="../assets/images/footer_logo.png" />
      </div>
      <div class="footer-right">
        <!-- <img src="../assets/images/plus12.png" class="level" /> -->
        <div v-show="showMail" class="mail-info">
          grandtrader.cs@iyagames.com
          <div class="main-ok" @click.stop="showMail = false">confirm</div>
        </div>
        <p class="medium" style="color: #fff">
          <!-- <a href="mailto:grandtrader.cs@iyagames.com">Contact Us</a> |  -->
          <span style="cursor: pointer" @click="showMail = !showMail">Contact Us</span> |
          <a href="https://sdkinit.iyagame.com/protocol?language=1&typeFlag=1&appId=10139" target="_blank"
            >Privacy Policy</a
          >
          |
          <a href="https://sdkinit.iyagame.com/protocol?language=1&typeFlag=2&appId=10139" target="_blank"
            >Service Terms</a
          >
        </p>
        <p class="medium">@SINGAPORE JUST GAME TECHNOLOGY PTE. LTD.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMail: false
    };
  },
  mounted() {},
  beforeCreate() {},
  created() {},
  methods: {
    toService() {
      let routeUrl = this.$router.resolve({
        path: '/terms',
        query: { pageType: 'service' }
      });
      window.open(routeUrl.href, '_blank');
    },
    toPrivacy() {
      let routeUrl = this.$router.resolve({
        path: '/terms',
        query: { pageType: 'privacy' }
      });
      window.open(routeUrl.href, '_blank');
    },
    onAlert() {
      //   window.alert('email:grandtrader.cs@iyagames.com')
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin disf {
  display: flex;
  display: -webkit-flex;
}
@mixin disf-center {
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 769px) {
  .common-footer {
    width: 100%;
    height: 196px;
    background-color: #0c1319;
    .footer-main {
      margin: 0 auto;
      width: 1220px;
      height: 196px;
      left: 0;
      bottom: 0;
      z-index: 2;
      @include disf;
      @include disf-center;
    }
    .logo_copyright {
      position: relative;
      width: 400px;
      text-align: right;
      &:after {
        content: '';
        position: absolute;
        width: 1px;
        height: 76px;
        right: 0;
        top: 50%;
        margin-top: -38px;
        background-color: #5e5e5e;
      }
      img {
        width: 220px;
        margin-right: 20px;
      }
    }
    .medium {
      line-height: 22px;
      a {
        color: #fff;
      }
    }
    .copy-right,
    .footer-btn {
      width: 325px;
      display: block;
      font-size: 10px;
      color: #b5b5b5;
      margin-top: 5px;
      a {
        color: #b5b5b5;
        font-family: 'NotoSansCJKsc-Regular';
        text-decoration: none;
        margin-right: 10px;
      }
    }
    .copy-right {
      padding-top: 0;
      margin-top: 0;
    }
    .logo {
      display: block;
      width: 216px;
      margin-bottom: 12px;
      img {
        height: auto;
      }
    }
    .footer-right {
      position: relative;
      display: block;
      width: 400px;
      padding-left: 20px;
      font-size: 11px;
      color: #b5b5b5;
      line-height: 20px;
      .level {
        position: absolute;
        width: 68px;
        height: 72px;
        left: 44px;
        top: 5px;
      }
      p {
        font-size: 12px;
      }
      .mail-info {
        position: absolute;
        top: -180px;
        left: 0;
        width: 560px;
        height: 152px;
        background-image: url('../assets/images/mail-bg.png');
        background-size: 100% 100%;
        font-size: 30px;
        color: #bf703c;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 40px;
        .main-ok {
          position: absolute;
          left: 50%;
          bottom: 16px;
          margin-left: -50px;
          width: 100px;
          height: 40px;
          background-image: url('../assets/images/mail-ok.png');
          background-size: 100% 100%;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .common-footer {
    height: 500px;
    .footer-main {
      &.fixed {
        position: fixed;
      }
      width: 100%;
      height: 500px;
      left: 0;
      bottom: 0;
      z-index: 2;
      background-color: #0c1319;
      @include disf;
      flex-direction: column;
      @include disf-center;
    }
    .logo_copyright {
      height: 110px;
      img {
        width: 355px;
        margin: 0 auto 30px;
        display: block;
      }
    }
    .medium {
      a {
        color: #fff;
      }
    }
    .copy-right,
    .footer-btn {
      border-top: 1px solid #494e53;
      width: 620px;
      display: block;
      padding-left: 76px;
      padding-top: 30px;
      font-size: 20px;
      color: #b5b5b5;
      line-height: 20px;
      white-space: nowrap;
      a {
        color: #b5b5b5;
        text-decoration: none;
        margin-right: 10px;
      }
    }
    .copy-right {
      border-top: none;
      padding-top: 0;
      margin-top: 18px;
    }
    .logo {
      display: block;
      width: 352px;
      height: 68px;
      margin-bottom: 30px;
    }
    .footer-right {
      position: relative;
      width: 620px;
      display: block;
      font-size: 16px;
      color: #b5b5b5;
      line-height: 28px;
      text-align: center;
      padding-top: 20px;
      border-top: 1px solid #bbbb;
      .level {
        position: absolute;
        width: 54px;
        height: 60px;
        left: 0;
        top: -90px;
      }
      p {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
